"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MirFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MirFilled = function MirFilled(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    rx: 3,
    fill: "#ECEFF5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#MirFilled_svg__MirFilled_svg__clip0_19_1885)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "MirFilled_svg__a",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 8,
    width: 9,
    height: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.424 8.444c.01.195.038.385.081.57.01.04.02.082.032.122l.014.05a3.26 3.26 0 003.108 2.278h4.304a2.558 2.558 0 00-.792-2.344 2.556 2.556 0 00-1.732-.676h-5.015z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#MirFilled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.03 23.515h44.474V3.293H-5.03v20.222z",
    fill: "url(#MirFilled_svg__MirFilled_svg__paint0_linear_19_1885)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.532 11.905v3.824h2.331v-2.153h2.346c1.226 0 2.271-.695 2.675-1.67h-7.352zM19.4 9.213l-1.632 3.537h-.166V8.444h-2.318v7.286h1.967c.517 0 .987-.3 1.203-.77l1.632-3.535h.166v4.305h2.318V8.444h-1.967c-.517 0-.987.3-1.203.77zm-10.796.189l.966 3.347h.166l.965-3.347a1.325 1.325 0 011.273-.958h2.316v7.286h-2.318v-4.305h-.166L10.48 15.73H8.825L7.5 11.425h-.166v4.305H5.016V8.444H7.33c.59 0 1.11.39 1.273.958z",
    fill: "#064"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "MirFilled_svg__MirFilled_svg__paint0_linear_19_1885",
    x1: 23.424,
    y1: 9.954,
    x2: 31.006,
    y2: 9.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50A9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3E91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "MirFilled_svg__MirFilled_svg__clip0_19_1885"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5 8)",
    d: "M0 0h26v8.293H0z"
  }))));
};

exports.MirFilled = MirFilled;
var _default = MirFilled;
exports.default = _default;